module.exports = __webpack_public_path__ + "img/hookah.00d0fe68.png";